export const VICTIMS_LOAD_PER_PAGE = 42;
export const VICTIMS_SEARCH_DEBOUNCE_MS = 500;
export const PREFERRED_SLUG_DEBOUNCE_MS = 500;
